import React, {useEffect} from 'react'
import {isEmpty} from 'lodash'

import TableItemLoader from 'components/TableItemLoader'
import {useDispatch, useSelector} from 'react-redux'
import {getShiftAppointments} from 'redux/slices/shiftSlice'
import CustomTable from 'components/table/CustomTable'
import {TableRow, TableHeader} from 'components/table/CustomTable'
import {TableCell} from 'components/table/CustomTable'
import CustomIcon from "../../../components/CustomIcon";
import {capitalizeFirstLetter} from "../../../helpers/stringHelper";

const AssociatedBookings = ({shift}) => {
  const dispatch = useDispatch()
  const headers = ['Booked By', 'Appointment Date', 'Quantity', 'Status']

  const {
    shiftAppointments,
    loadingShiftAppointments,
    errorShiftAppointments,
  } = useSelector((state) => state.shifts)

  useEffect(() => {
    getAssociatedAppointments()
  }, [])

  const getAssociatedAppointments = () => {
    dispatch(getShiftAppointments(shift.id))
  }

  return (
    <div>
      <CustomTable>
        <thead>
        <TableRow>
          {headers.map((value, index) => (
            <TableHeader
              key={index}>
              {value}
            </TableHeader>
          ))}
        </TableRow>
        </thead>

        {isEmpty(shiftAppointments) ||
        loadingShiftAppointments ||
        !isEmpty(errorShiftAppointments) ? (
          <tbody>
          <tr>
            <td colSpan={4}>
              <TableItemLoader
                loading={loadingShiftAppointments}
                isEmpty={isEmpty(shiftAppointments)}
                key="shift-list"
                error={errorShiftAppointments}
                retry={() => getAssociatedAppointments()}
                count={10}
              ></TableItemLoader>
            </td>
          </tr>
          </tbody>
        ) : (
          <>
            {shiftAppointments.map((appointment) => (
              <TableRow>
                <TableCell>
                  <div
                    className="font-medium">{`${capitalizeFirstLetter(appointment?.requested_by?.first_name)} ${capitalizeFirstLetter(appointment?.requested_by?.last_name)}`}</div>
                  <div className="font-light flex items-center space-x-1"><CustomIcon icon="phone" size="sm"/>
                    <span>{appointment?.requested_by?.mobile}</span></div>
                </TableCell>
                <TableCell>{appointment?.appointment_date}</TableCell>
                <TableCell>{appointment?.quantity}</TableCell>
                <TableCell>
                  <span
                    className={`${appointment?.status === "ASSIGNED" ? "bg-blue-100 text-secondary-500" : appointment?.status === "COMPLETED" ? "bg-green-100 text-primary-800" : "bg-rand-300 text-cyan-800"}  font-semibold rounded text-xs py-1 px-2 font-semibold tracking-wide`}>
                    {capitalizeFirstLetter(appointment?.status)}
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </>
        )}
      </CustomTable>
    </div>
  )
}

export default AssociatedBookings
